import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as o}from"../../icon-registry.js";const m=o("trustly",t`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            static
            fill="none">
            <path
                d="M0 10.6457H8.39544V4.1483L15.0985 10.6457L8.39544 17.1335V20.4545H16.532V10.6457H24V3H0V10.6457Z"
                fill="#4CE075" />
        </svg>
    `);export{m as Trustly};
